/**
 * Minimum interactive box for page-local controls on Workspace surfaces
 * (DESIGN.md §8 touch targets): 48px on phones and tablets, 40px from `md`
 * up, where a mouse has the precision for the tighter desktop density.
 *
 * This enlarges the hit box, not the glyph — keep the visual inside compact
 * (a 22px pill, a 20px icon) and let the box supply the target.
 */
export const WORKSPACE_TARGET_MIN_HEIGHT = { xs: 48, md: 40 } as const;
